import React from "react"
import { Navigate } from "react-router-dom"

import { ADMIN_ROUTES, FEATURES_TYPE, USER_ROUTES } from '@constants'
import AppLayout from "Layout"
import UserSettingPage from "./Settings"
import CustomMappingPage from './CustomMapping'


export const UserSettingsRoutes = {
	id: FEATURES_TYPE.COMMON,
	path: USER_ROUTES.PATH,
	title: USER_ROUTES.TITLE,
	icon: 'user',
	element: <AppLayout/>,
	children: [{
		element: <Navigate to={USER_ROUTES.SETTINGS_PATH} replace/>, index: true
	}, {
		path: USER_ROUTES.SETTINGS_PATH,
		title: USER_ROUTES.SETTINGS_SUBTITLE,
		element: <UserSettingPage/>
	},  {
		path: USER_ROUTES.CUSTOM_MAPPING_PATH,
		title: USER_ROUTES.CUSTOM_MAPPING_SUBTITLE,
		element: <CustomMappingPage/>
	}]
}